<template>
  <FriedButton
    :class="{ 'active-filter': activeFilter }"
    :data-external="dataExternal"
    :button-type="ButtonType.Tertiary"
    :active="active"
  >
    <template #rightIcon>
      <FriedIcon icon="filter" />
    </template>
    {{ text }}
  </FriedButton>
</template>

<script lang="ts">
import { ButtonType } from '@getaccept/fried-tofu';
import { defineComponent, watch } from 'vue';

export default defineComponent({
  props: {
    dataExternal: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
    },
    activeFilter: {
      type: Boolean,
    },
  },
  emits: ['toggle-active'],
  setup(props, { emit }) {
    watch(
      () => props.active,
      () => {
        emit('toggle-active', props.active);
      }
    );

    return {
      ButtonType,
    };
  },
});
</script>

<style lang="scss" scoped>
.active-filter {
  &.button.ga-tertiary {
    background-color: var(--blue-95);
    color: var(--blue-45);
  }
}
</style>
